import * as DateFormatter from "../../utils/DateFormatter";

class AgentPerson {
    constructor(jsonResponse) {
        this.firstName = jsonResponse["firstName"];
        this.lastName = jsonResponse["lastName"];
        this.dateOfBirth = jsonResponse["dateOfBirth"];
        this.title = jsonResponse["title"];
        this.gender = jsonResponse["gender"];
    }

}

class AgentAddress {
    constructor(jsonResponse) {
        this.streetNumber = jsonResponse["streetNumber"];
        this.streetName = jsonResponse["streetName"];
        this.suburb = jsonResponse["suburb"];
        this.city = jsonResponse["city"];
        this.province = jsonResponse["province"];
        this.postalCode = jsonResponse["postalCode"];
    }

}

class AgentContacts {
    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.contactType = jsonResponse["contactType"];
        this.contactName = jsonResponse["contactName"]
        this.contactValue = jsonResponse["contactValue"];
        this.primary = jsonResponse["primary"];
    }

}

class AgentIdentity {
    constructor(jsonResponse) {
        this.idType = jsonResponse["idType"];
        this.idNumber = jsonResponse["idNumber"];
        this.idExpiryDate = jsonResponse["idExpiryDate"];
        this.idIssuingCountry = jsonResponse["idIssuingCountry"];
        this.nationality = jsonResponse["nationality"];
        this.originCountry = jsonResponse["originCountry"];

    }

}

class AgentTraining {
    constructor(jsonResponse) {
        this.trainingDate = jsonResponse["trainingDate"];
        this.trainingMark = jsonResponse["trainingMark"];
        this.trainingPlatform = jsonResponse["trainingPlatform"];

    }
}


class AgentDocuments {
    constructor(jsonResponse) {
        this.documentType = jsonResponse["agentDocumentType"];
        this.metaDataId = jsonResponse["metaDataId"];
        this.id = jsonResponse["id"];
        this.preSignedUrl = jsonResponse["preSignedUrl"];
    }

}


export default class AgentRetrieveResponse {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.dateCreated = DateFormatter.prettifyDate(jsonResponse["dateCreated"]);
        this.dateUpdated = DateFormatter.prettifyDate(jsonResponse["dateUpdated"]);
        this.externalAgentIdentifier = jsonResponse["externalAgentIdentifier"];
        this.agentCode = jsonResponse["agentCode"];
        this.organisationId = jsonResponse["organisationId"];
        this.creatingUserId = jsonResponse["creatingUserId"];
        this.status = jsonResponse["status"];
        this.agentType = jsonResponse["agentType"];
        this.person = new AgentPerson(jsonResponse["person"]);
        this.address = new AgentAddress(jsonResponse["address"]);
        this.contacts = jsonResponse["contacts"].map((contact) => new AgentContacts(contact));
        this.identity = new AgentIdentity(jsonResponse["identity"]);
        if (jsonResponse["training"] === null) {
            this.training = null
        } else {
            this.training = new AgentTraining(jsonResponse["training"]);
        }
        this.documents = jsonResponse["documents"].map((document) => new AgentDocuments(document));
        this.organisationId = jsonResponse["organisationId"];
        this.organisationName = jsonResponse["organisationName"];
        this.manager = jsonResponse["manager"];
    }
}
